import { HttpMethods, makeRequest } from '../helpers/http.helper';
import { OrganizationRequest, UpdateOrganizationRequest, OrganizationQueryParams } from '../types/organization.type';

export const createOrganization = (organization: OrganizationRequest) => {
    return makeRequest({
        url: "/organization",
        method: HttpMethods.POST,
        data: organization,
    });
};

export const getOrganizations = (params?: OrganizationQueryParams) => {
    return makeRequest({
        url: "/organization",
        method: HttpMethods.GET,
        params: params || {},
    });
};

export const getOrganization = (organizationId: string) => {
    return makeRequest({
        url: `/organization/${organizationId}`,
        method: HttpMethods.GET,
    });
};

/** The waste types this organization handles — what its pickers offer. */
export const getOrganizationWasteTypes = (organizationId: string) => {
    return makeRequest({
        url: `/organization/${organizationId}/waste-types`,
        method: HttpMethods.GET,
    });
};

/** Replaces the whole selection. Deselecting only stops a waste type being
 *  offered for new work; existing records keep it. */
export const replaceOrganizationWasteTypes = (organizationId: string, materialIds: string[]) => {
    return makeRequest({
        url: `/organization/${organizationId}/waste-types`,
        method: HttpMethods.PUT,
        data: { material_ids: materialIds },
    });
};

/** One waste type this organization handles, with its own reference code. */
export type OrganizationWasteType = {
    material_id: string;
    name: string;
    code?: string | null;
    parent_category?: string | null;
    status: string;
    client_custom_id?: string | null;
};

/** Takes one catalog waste type into the organization's basket. Organizations pick
 *  from the shared catalog rather than defining waste types of their own. */
export const addOrganizationWasteType = (
    organizationId: string,
    materialId: string,
    clientCustomId?: string | null,
) => {
    return makeRequest({
        url: `/organization/${organizationId}/waste-types`,
        method: HttpMethods.POST,
        data: { material_id: materialId, client_custom_id: clientCustomId || null },
    });
};

/** Changes the organization's own code for a waste type. Everything else about it
 *  belongs to the shared catalog. */
export const updateOrganizationWasteType = (
    organizationId: string,
    materialId: string,
    clientCustomId?: string | null,
) => {
    return makeRequest({
        url: `/organization/${organizationId}/waste-types/${materialId}`,
        method: HttpMethods.PATCH,
        data: { client_custom_id: clientCustomId || null },
    });
};

/** Stops offering a waste type here. Existing records keep it. */
export const removeOrganizationWasteType = (organizationId: string, materialId: string) => {
    return makeRequest({
        url: `/organization/${organizationId}/waste-types/${materialId}`,
        method: HttpMethods.DELETE,
    });
};

export const updateOrganization = (organizationId: string, organization: UpdateOrganizationRequest) => {
    return makeRequest({
        url: `/organization/${organizationId}`,
        method: HttpMethods.PUT,
        data: organization,
    });
};

export const deleteOrganization = (organizationId: string) => {
    return makeRequest({
        url: `/organization/${organizationId}`,
        method: HttpMethods.DELETE,
    });
};
